import { Chess, type Square } from 'chess.js';

function loadPosition(fen: string): Chess | null {
  try {
    return new Chess(fen);
  } catch {
    return null;
  }
}

function applyUci(chess: Chess, uci: string): boolean {
  if (!uci || uci.length < 4) return false;
  try {
    return !!chess.move({
      from: uci.substring(0, 2) as Square,
      to: uci.substring(2, 4) as Square,
      promotion: uci.length > 4 ? uci[4] : undefined,
    });
  } catch {
    return false;
  }
}

/**
 * Validates a puzzle attempt against the stored Lichess solution line.
 * Exact match always wins. For mate-in-one positions only, any other legal
 * move that immediately checkmates is also accepted. An unreadable position
 * falls back to exact-match validation.
 */
export function isPuzzleMoveCorrect(fen: string, setupMove: string, expectedMove: string, userMove: string): boolean {
  if (!expectedMove || !userMove) return false;
  if (userMove === expectedMove) return true;

  const base = loadPosition(fen);
  if (!base) return false;
  if (setupMove && !applyUci(base, setupMove)) return false;

  const expectedLine = new Chess(base.fen());
  if (!applyUci(expectedLine, expectedMove) || !expectedLine.isCheckmate()) {
    return false;
  }

  const userLine = new Chess(base.fen());
  return applyUci(userLine, userMove) && userLine.isCheckmate();
}
